<!-- Toast notifications -->
<p-toast key="main"></p-toast>

<!-- Modern Header Section -->
<div *ngIf="userRole != 'customer-switch'" class="m-4">
  <div class="webhook-header">
    <div class="header-content">
      <div class="header-left">
        <h1 class="webhook-title">
          <i class="pi pi-link mr-3"></i>
          Switch Webhook Submit
        </h1>
        <p class="webhook-subtitle">
          Create and configure webhook submission points for users
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Client Component (for customer-switch role) -->
<div *ngIf="userRole == 'customer-switch'; else showSwitchForm">
  <app-switch-webhook-client></app-switch-webhook-client>
</div>

<!-- Main Form (for other roles) -->
<ng-template #showSwitchForm>
  <div class="webhook-content">
    <form
      [formGroup]="switch_form"
      (ngSubmit)="submitWebhook()"
      class="webhook-form"
    >
      <!-- User Webhooks Section -->
      <div class="form-section">
        <div class="section-header">
          <h2 class="section-title">
            <i class="pi pi-users mr-2"></i>
            User Webhooks
          </h2>
          <p class="section-description">Assign webhooks to specific users</p>
        </div>

        <div formArrayName="users_webhooks" class="form-array-container">
          <div
            *ngFor="
              let userWebhooks of usersWebhooksArray.controls;
              index as i;
              last as isLast;
              first as isFirst
            "
            [formGroupName]="i"
            class="form-array-item"
          >
            <div class="array-item-card">
              <div class="array-item-header">
                <h3 class="item-number">User Webhook {{ i + 1 }}</h3>
                <div class="array-item-actions">
                  <button
                    *ngIf="isLast"
                    pButton
                    pRipple
                    type="button"
                    icon="pi pi-plus"
                    class="modern-button-icon success"
                    (click)="addUsersWebhooks()"
                    pTooltip="Add another user webhook"
                    tooltipPosition="top"
                  ></button>
                  <button
                    *ngIf="!isFirst"
                    pButton
                    pRipple
                    type="button"
                    icon="pi pi-minus"
                    class="modern-button-icon danger"
                    (click)="removeUsersWebhooks(i)"
                    pTooltip="Remove this user webhook"
                    tooltipPosition="top"
                  ></button>
                </div>
              </div>

              <div class="array-item-content">
                <div class="form-grid">
                  <div class="form-field">
                    <label class="field-label">
                      <i class="pi pi-user mr-2"></i>
                      Assign User
                    </label>
                    <p-dropdown
                      [options]="switch_users"
                      optionLabel="username"
                      optionValue="id"
                      formControlName="user_id"
                      placeholder="Select a User"
                      (onChange)="dropdownChange($event, i)"
                      appendTo="body"
                      class="modern-dropdown"
                      [class.field-error]="
                        submitted &&
                        userWebhooks.get('user_id')?.invalid &&
                        (userWebhooks.get('user_id')?.touched ||
                          userWebhooks.get('user_id')?.pristine)
                      "
                    ></p-dropdown>
                    <div
                      *ngIf="
                        submitted &&
                        userWebhooks.get('user_id')?.invalid &&
                        (userWebhooks.get('user_id')?.touched ||
                          userWebhooks.get('user_id')?.pristine)
                      "
                      class="error-message"
                    >
                      <i class="pi pi-exclamation-circle mr-1"></i>
                      A user is required
                    </div>
                  </div>

                  <div class="form-field">
                    <label class="field-label">
                      <i class="pi pi-globe mr-2"></i>
                      Webhook Endpoint
                    </label>
                    <div class="webhook-url-container">
                      <span
                        *ngIf="userWebhooks.get('webhook')?.value"
                        class="webhook-prefix"
                      >
                        {{ userWebhooks.get("webhook")?.value }}
                      </span>
                      <input
                        id="webhook_url"
                        formControlName="webhook_url"
                        pInputText
                        type="text"
                        placeholder="Enter webhook endpoint"
                        class="modern-input webhook-url-input"
                        [class.field-error]="
                          submitted &&
                          userWebhooks.get('webhook_url')?.invalid &&
                          (userWebhooks.get('webhook_url')?.touched ||
                            userWebhooks.get('webhook_url')?.pristine)
                        "
                      />
                    </div>
                    <div
                      *ngIf="
                        submitted &&
                        userWebhooks.get('webhook_url')?.invalid &&
                        (userWebhooks.get('webhook_url')?.touched ||
                          userWebhooks.get('webhook_url')?.pristine)
                      "
                      class="error-message"
                    >
                      <i class="pi pi-exclamation-circle mr-1"></i>
                      Webhook URL is required
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Webhook Details Section -->
      <div class="form-section">
        <div class="section-header">
          <h2 class="section-title">
            <i class="pi pi-info-circle mr-2"></i>
            Webhook Details
          </h2>
          <p class="section-description">Basic information about the webhook</p>
        </div>

        <div class="section-content">
          <div class="form-grid">
            <div class="form-field">
              <label class="field-label">
                <i class="pi pi-tag mr-2"></i>
                Submit Point Name
              </label>
              <input
                id="webhook_name"
                formControlName="webhook_name"
                pInputText
                type="text"
                placeholder="Enter submit point name"
                class="modern-input"
                [class.field-error]="
                  submitted &&
                  switch_form.get('webhook_name')?.invalid &&
                  (switch_form.get('webhook_name')?.touched ||
                    switch_form.get('webhook_name')?.pristine)
                "
              />
              <div
                *ngIf="
                  submitted &&
                  switch_form.get('webhook_name')?.invalid &&
                  (switch_form.get('webhook_name')?.touched ||
                    switch_form.get('webhook_name')?.pristine)
                "
                class="error-message"
              >
                <i class="pi pi-exclamation-circle mr-1"></i>
                Webhook name is required
              </div>
            </div>

            <div class="form-field full-width">
              <label class="field-label">
                <i class="pi pi-file-edit mr-2"></i>
                Description
              </label>
              <textarea
                placeholder="Enter webhook description"
                formControlName="description"
                [rows]="5"
                pInputTextarea
                [autoResize]="true"
                class="modern-textarea"
                [class.field-error]="
                  submitted &&
                  switch_form.get('description')?.invalid &&
                  (switch_form.get('description')?.touched ||
                    switch_form.get('description')?.pristine)
                "
              ></textarea>
              <div
                *ngIf="
                  submitted &&
                  switch_form.get('description')?.invalid &&
                  (switch_form.get('description')?.touched ||
                    switch_form.get('description')?.pristine)
                "
                class="error-message"
              >
                <i class="pi pi-exclamation-circle mr-1"></i>
                Description is required
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Custom Fields Section -->
      <div class="form-section">
        <div class="section-header">
          <h2 class="section-title">
            <i class="pi pi-sliders-h mr-2"></i>
            Custom Fields
          </h2>
          <p class="section-description">
            Add custom fields to collect additional data
          </p>
        </div>

        <div formArrayName="fields" class="form-array-container">
          <div
            *ngFor="
              let fields of fieldArray.controls;
              index as i;
              last as isLast;
              first as isFirst
            "
            [formGroupName]="i"
            class="form-array-item"
          >
            <div class="array-item-card">
              <div class="array-item-header">
                <h3 class="item-number">Field {{ i + 1 }}</h3>
                <div class="array-item-actions">
                  <button
                    *ngIf="isLast"
                    pButton
                    pRipple
                    type="button"
                    icon="pi pi-plus"
                    class="modern-button-icon success"
                    (click)="addInputField()"
                    pTooltip="Add another field"
                    tooltipPosition="top"
                  ></button>
                  <button
                    *ngIf="!isFirst"
                    pButton
                    pRipple
                    type="button"
                    icon="pi pi-minus"
                    class="modern-button-icon danger"
                    (click)="removeInputField(i)"
                    pTooltip="Remove this field"
                    tooltipPosition="top"
                  ></button>
                </div>
              </div>

              <div class="array-item-content">
                <div class="form-grid">
                  <div class="form-field">
                    <label class="field-label">
                      <i class="pi pi-pencil mr-2"></i>
                      Field Title
                    </label>
                    <input
                      pInputText
                      formControlName="field_title"
                      placeholder="Enter field title"
                      class="modern-input"
                      [class.field-error]="
                        submitted &&
                        fields.get('field_title')?.invalid &&
                        (fields.get('field_title')?.touched ||
                          fields.get('field_title')?.pristine)
                      "
                    />
                    <div
                      *ngIf="
                        submitted &&
                        fields.get('field_title')?.errors &&
                        (fields.get('field_title')?.touched ||
                          fields.get('field_title')?.dirty)
                      "
                      class="error-message"
                    >
                      <i class="pi pi-exclamation-circle mr-1"></i>
                      <span
                        *ngIf="fields.get('field_title')?.hasError('required')"
                      >
                        Field title is required
                      </span>
                      <span
                        *ngIf="
                          fields.get('field_title')?.hasError('specialChars')
                        "
                      >
                        Special characters are not allowed
                      </span>
                    </div>
                  </div>

                  <div class="form-field">
                    <label class="field-label">
                      <i class="pi pi-list mr-2"></i>
                      Field Type
                    </label>
                    <p-dropdown
                      [options]="switch_fields"
                      optionLabel="field_name"
                      optionValue="field_name"
                      formControlName="field_name"
                      placeholder="Select field type"
                      class="modern-dropdown"
                      appendTo="body"
                      (onChange)="onDropdownChange($event, i)"
                      [class.field-error]="
                        submitted &&
                        fields.get('field_name')?.invalid &&
                        (fields.get('field_name')?.touched ||
                          fields.get('field_name')?.pristine)
                      "
                    ></p-dropdown>
                    <div
                      *ngIf="
                        submitted &&
                        fields.get('field_name')?.invalid &&
                        (fields.get('field_name')?.touched ||
                          fields.get('field_name')?.pristine)
                      "
                      class="error-message"
                    >
                      <i class="pi pi-exclamation-circle mr-1"></i>
                      Field type is required
                    </div>
                  </div>
                </div>

                <!-- Dropdown Options (only show for dropdown field type) -->
                <div
                  *ngIf="fields.get('field_name')?.value === 'dropdown'"
                  formArrayName="field_data"
                  class="dropdown-options-container"
                >
                  <label class="field-label">
                    <i class="pi pi-list mr-2"></i>
                    Dropdown Options
                  </label>
                  <div class="options-list">
                    <div
                      *ngFor="
                        let data of inputFieldData(i).controls;
                        index as j;
                        last as isLast;
                        first as isFirst
                      "
                      class="option-item"
                    >
                      <input
                        pInputText
                        [formControlName]="j"
                        type="text"
                        placeholder="Enter option value"
                        class="modern-input option-input"
                        [class.field-error]="
                          submitted &&
                          data.invalid &&
                          (data.touched || data.pristine)
                        "
                      />
                      <div class="option-actions">
                        <button
                          *ngIf="isLast"
                          pButton
                          pRipple
                          type="button"
                          icon="pi pi-plus"
                          class="modern-button-icon success small"
                          (click)="addInputFieldData(i)"
                          pTooltip="Add option"
                          tooltipPosition="top"
                        ></button>
                        <button
                          *ngIf="!isFirst"
                          pButton
                          pRipple
                          type="button"
                          icon="pi pi-minus"
                          class="modern-button-icon danger small"
                          (click)="removeInputFieldData(i, j)"
                          pTooltip="Remove option"
                          tooltipPosition="top"
                        ></button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- add option to make field required -->
                <div class="form-field checkbox-field">
                  <div class="p-field-checkbox">
                    <p-checkbox
                      formControlName="field_required"
                      [binary]="true"
                      inputId="field_required_{{ i }}"
                      class="modern-checkbox"
                    ></p-checkbox>
                    <label for="field_required_{{ i }}" class="checkbox-label">
                      <i class="pi pi-check mr-2"></i>
                      Required Field
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Form Actions -->
      <div class="form-actions">
        <button
          pButton
          pRipple
          type="submit"
          label="Create Submit Point"
          icon="pi pi-plus"
          class="modern-button primary"
          [loading]="loading"
          [disabled]="loading"
        ></button>
      </div>
    </form>
  </div>
</ng-template>
